import type { TripListResponse } from "../../types/operations/tripList.type";

export const mockTripList = {
  default: {
    summary: {
      today: { trips: 9, bills: 50, weight: 21600 },
      tomorrow: { trips: 9, bills: 50, weight: 21600 },
      enRoute: { trips: 9, bills: 0, weight: 0 },
      checkedIn: { trips: 9, bills: 0, weight: 0 },
      closingSoon: { trips: 9, bills: 0, weight: 0 },
    },
    trips: [],
  },
} satisfies Record<string, TripListResponse>;
